var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStorms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.146 13.794c-1.012-5.01-5.478-8.72-10.646-8.72-5.17 0-9.634 3.71-10.646 8.72-3.362.258-6.021 3.07-6.021 6.497a6.53 6.53 0 006.522 6.521h2.898a.724.724 0 100-1.449h-2.898a5.079 5.079 0 01-5.073-5.072c0-2.797 2.276-5.073 5.038-5.079.008.002.017.001.025.002l.009.004a.69.69 0 00.1.007h.003c.377 0 .766.05 1.155.148a.615.615 0 00.088.03 5.098 5.098 0 013.049 2.351.725.725 0 001.255-.724 6.56 6.56 0 00-3.82-2.997.65.65 0 00-.104-.037 6.456 6.456 0 00-.76-.155c.967-4.222 4.782-7.318 9.18-7.318 4.397 0 8.213 3.096 9.18 7.318a6.415 6.415 0 00-.76.156.721.721 0 00-.104.036 6.568 6.568 0 00-3.82 2.997.725.725 0 001.254.725 5.1 5.1 0 013.049-2.352.737.737 0 00.088-.03 4.75 4.75 0 011.156-.148c.047.001.056.003.102-.007a5.078 5.078 0 015.072 5.073 5.079 5.079 0 01-5.072 5.072h-2.899a.724.724 0 100 1.45h2.899a6.53 6.53 0 006.521-6.522c0-3.427-2.658-6.239-6.02-6.497z",
    fill: "var(--color-secondary)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.166 29.334h-3.849l4.348-4.89a.668.668 0 00-.997-.887l-5.334 6a.666.666 0 00.498 1.11h3.97l-3.829 4.925a.666.666 0 101.052.818l4.667-6a.667.667 0 00-.526-1.076z",
    fill: "var(--color-secondary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorms);
export default __webpack_public_path__ + "static/media/storms.485d53110522243f4678b0dbdd3a8ec3.svg";
export { ForwardRef as ReactComponent };